import {
  DropdownCustomFieldPredefinedValue,
  ICustomField,
  MultiSelectCustomFieldPredefinedValue,
  SelectAssigneeCustomFieldPredefinedValues,
} from "@webapp/custom-fields/models/custom-fields.models";
import { IGridFilterDefinition } from "./models";

export const customFieldToFilterDefinition = (customField: ICustomField): IGridFilterDefinition => {
  const create = (def: Partial<IGridFilterDefinition>): IGridFilterDefinition => {
    def.displayName = customField.label;
    def.fieldName = `customFields.${customField.name}`;
    def.isCustomField = true;

    if (customField.operationalType === "session" && customField.targetIds?.length) {
      def.dependsOn = { fieldName: "sessionId", values: [...customField.targetIds] };
    }

    return def as IGridFilterDefinition;
  };

  switch (customField.visualizationKind) {
    case "gtmhub.multiselect":
      return create({
        dataType: "array",
        arrayType: "static",
        entries: ((customField.settings.predefinedValues as MultiSelectCustomFieldPredefinedValue[]) || []).map((x) => x.value),
        supportedOperators: ["isOneOf"],
        defaultOperator: "isOneOf",
      });

    case "gtmhub.select":
      return create({
        dataType: "enum",
        entries: ((customField.settings.predefinedValues as DropdownCustomFieldPredefinedValue[]) || []).map((x) => x.value),
        supportedOperators: ["equals", "notEqual"],
        defaultOperator: "equals",
      });

    case "gtmhub.text":
    case "gtmhub.textarea":
      return create({
        dataType: "text",
        supportedOperators: ["equals", "notEqual", "contains", "doesNotContain"],
        defaultOperator: "equals",
      });

    case "gtmhub.datepicker":
      return create({
        dataType: "date",
        supportedOperators: ["equals", "notEqual"],
        defaultOperator: "equals",
        local: true,
      });

    case "gtmhub.selectassignee": {
      const predefinedValues = customField.settings.predefinedValues as SelectAssigneeCustomFieldPredefinedValues;
      return create({
        dataType: "array",
        arrayType: predefinedValues.targetGroup === "both" ? "assignee" : predefinedValues.targetGroup,
        supportedOperators: ["isOneOf"],
        defaultOperator: "isOneOf",
      });
    }
    case "gtmhub.numeric":
      return create({
        dataType: "numeric",
        supportedOperators: ["equals", "notEqual"],
        defaultOperator: "equals",
      });
  }
};
